import { useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import Select from "react-select";
import {
  getCategory,
  getSubCategory,
  create_product_master,
  updateProductMaster,
  getRawMaterials,
  getProductMaster,
  apiClient,
} from "../../../Utility/Api";
import { WarehouseContext } from "../../../Utility/UserContext";

const parseLimitToGrams = (limitStr) => {
  if (!limitStr) return 1000; // default 1 Kg = 1000g
  const match = String(limitStr).match(/([\d.]+)\s*(kg|g|l|ml|kilogram|gram|litre|liter|milliliter|pcs)?/i);
  if (!match) return 1000;
  const val = parseFloat(match[1]);
  const unit = (match[2] || 'kg').toLowerCase();
  if (unit.startsWith('k') || unit.startsWith('l') || match[2] === undefined) {
    return val * 1000;
  }
  return val;
};

const parseLimitNumber = (limitStr) => {
  if (!limitStr) return "1";
  const match = String(limitStr).match(/([\d.]+)/);
  return match ? match[1] : "1";
};

const displayLimit = (limit) => {
  if (!limit) return '1 Kg';
  const str = String(limit).toLowerCase();
  if (str.includes('kg')) return limit;
  return `${limit} Kg`;
};

const customSelectStyles = {
  option: (provided, state) => {
    const isProduct = state.data?.itemType === "product";
    const color = isProduct ? "#d97706" : "#0b5ed7";
    const bg = isProduct
      ? state.isFocused ? "#fffbe6" : "#ffffff"
      : state.isFocused ? "#eef6ff" : "#ffffff";

    return {
      ...provided,
      color: color,
      backgroundColor: bg,
      fontWeight: 500,
      fontSize: "13px",
      padding: "6px 12px",
      cursor: "pointer",
    };
  },
  groupHeading: (provided) => ({
    ...provided,
    fontWeight: "bold",
    fontSize: "11px",
    textTransform: "uppercase",
    color: "#495057",
    padding: "6px 12px 2px",
  }),
  control: (provided, state) => ({
    ...provided,
    minHeight: "42px",
    height: "42px",
    fontSize: "13px",
    borderRadius: "0.25rem",
    borderColor: state.isFocused ? "#126efd" : "#dee2e6",
    boxShadow: state.isFocused ? "#126efd" : "none",
    backgroundColor: "#ffffff",
    outline: "none",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      borderColor: state.isFocused ? "#126efd" : "#dee2e6",
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "100%",
    padding: "0 8px",
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
    whiteSpace: "nowrap",
  }),
  input: (provided) => ({
    ...provided,
    margin: "0",
    padding: "0",
    color: "#212529",
    fontSize: "13px",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#6c757d",
    fontSize: "13px",
    margin: "0",
    position: "relative",
    transform: "none",
    top: "auto",
    lineHeight: "normal",
    whiteSpace: "nowrap",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "100%",
    display: "flex",
    alignItems: "center",
    padding: "0",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: "0 4px",
    color: "#6c757d",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: "0 2px",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#212529",
    fontWeight: 500,
    fontSize: "13px",
    margin: "0",
    position: "relative",
    transform: "none",
    top: "auto",
    lineHeight: "normal",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "calc(100% - 15px)",
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

export const EditProductMaster = ({
  showModal,
  setShowModal,
  setSelectedProduct,
  fetchProducts,
  selectedProduct,
  AddorEdit,
  setCurrentPage,
}) => {
  const { showLoader, hideLoader, shopItem, UserItem, warehouse } =
    useContext(WarehouseContext);

  const [formData, setFormData] = useState({
    title: "",
    package_qty: "",
    cat_id: "",
    subcat_id: "",
    box_barcode: "",
    product_code: "",
    unit: "",
    box_qty: "",
    box_sales: "",
    reorder_point: "",
    status: "1",
    shop_id: shopItem?.shop_id || "0",
    created_by: UserItem?.user_id || "0",
    product_image: "",
    weight_limit: "1",
  });

  const [Category, setCategory] = useState([]);
  const [SubCategory, setSubCategory] = useState([]);
  const [rawMaterialList, setRawMaterialList] = useState([]);
  const [finishedProductList, setFinishedProductList] = useState([]);
  const [ingredientsList, setIngredientsList] = useState([]);
  const [showIngredients, setShowIngredients] = useState(true);
  const [errors, setErrors] = useState({});
  const [ingredientToDeleteIndex, setIngredientToDeleteIndex] = useState(null);

  useEffect(() => {
    fetchCategory();
    fetchSubCategory();
    fetchRawMaterials();
    fetchFinishedProducts();

    if (selectedProduct) {
      setFormData({
        title: selectedProduct?.title || "",
        package_qty: selectedProduct?.package_qty || "",
        cat_id: selectedProduct?.cat_id || "",
        box_qty: selectedProduct?.box_qty || "",
        sales_price: selectedProduct?.sales_price || "",
        box_barcode: selectedProduct?.box_barcode || "",
        product_code: selectedProduct?.product_code || "",
        box_sales: selectedProduct?.box_sales || "",
        subcat_id: selectedProduct?.subcat_id || "",
        reorder_point: selectedProduct?.reorder_point || "",
        unit: selectedProduct?.unit || "",
        status: selectedProduct?.status?.toString() || "",
        created_by: UserItem?.user_id || "0",
        product_image: selectedProduct?.product_image
          ? (selectedProduct.product_image.startsWith("http")
            ? selectedProduct.product_image
            : `${apiClient.defaults.baseURL}${selectedProduct.product_image.startsWith("/") ? "" : "/"}${selectedProduct.product_image}`)
          : "",
        weight_limit: parseLimitNumber(selectedProduct?.weight_limit),
      });


      try {
        if (selectedProduct.ingridents) {
          const ingredients = JSON.parse(selectedProduct.ingridents);
          if (ingredients && ingredients.length > 0) {
            setIngredientsList(ingredients);
            setShowIngredients(true);
          }
        }
      } catch (error) {
        console.error("Error parsing ingredients:", error);
        setIngredientsList([]);
      }
    } else {
      resetForm();
    }
  }, [selectedProduct]);

  const fetchCategory = async () => {
    try {
      const response = await getCategory();
      if (response.data.data) {
        setCategory(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching category data:", error);
    }
  };

  const fetchSubCategory = async () => {
    try {
      const response = await getSubCategory();
      if (response.data.data) {
        setSubCategory(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching subcategory data:", error);
    }
  };


  const fetchRawMaterials = async () => {
    try {
      const params = {
        shop_id: shopItem?.shop_id || "0",
        created_by: UserItem?.user_id || "0",
        // ware_id: warehouse?.id || "1", // default warehouse ID
      };

      const response = await getRawMaterials(params);

      if (response.data && response.data.data) {
        setRawMaterialList(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching raw materials:", error);
    }
  };

  const fetchFinishedProducts = async () => {
    try {
      const response = await getProductMaster();
      if (response.data && response.data.data) {
        // Exclude current product if editing
        const currentProdId = selectedProduct?.product_id || selectedProduct?.id;
        const filtered = response.data.data.filter(
          p => String(p.product_id || p.id) !== String(currentProdId)
        );
        setFinishedProductList(filtered);
      }
    } catch (error) {
      console.error("Error fetching finished products:", error);
    }
  };


  const handleIngredientChange = (index, field, value) => {
    const updatedIngredients = [...ingredientsList];
    updatedIngredients[index][field] = value;
    setIngredientsList(updatedIngredients);
  };

  const addIngredient = () => {
    setIngredientsList([
      { id: "", qty: "", unit: "grams" },
      ...ingredientsList
    ]);
  };

  const removeIngredient = (index) => {
    const updatedIngredients = [...ingredientsList];
    updatedIngredients.splice(index, 1);
    setIngredientsList(updatedIngredients);
  };


  const validateIngredients = () => {
    if (showIngredients && ingredientsList.length === 0) {
      toast.error("At least one ingredient is required when ingredients section is enabled");
      return false;
    }

    if (showIngredients) {
      for (let i = 0; i < ingredientsList.length; i++) {
        const ing = ingredientsList[i];
        if (!ing.id) {
          toast.error(`Please select raw material for ingredient #${i + 1}`);
          return false;
        }
      }


      const uniqueIngredientIds = new Set();
      for (let i = 0; i < ingredientsList.length; i++) {
        if (uniqueIngredientIds.has(ingredientsList[i].id)) {
          toast.error("Duplicate ingredients are not allowed");
          return false;
        }
        uniqueIngredientIds.add(ingredientsList[i].id);
      }
    }

    return true;
  };


  const getAvailableRawMaterials = (currentIndex) => {
    const selectedIds = ingredientsList
      .filter((ing) => (ing.item_type || "raw") === "raw")
      .map(ing => String(ing.id));

    return rawMaterialList.filter(rm => !selectedIds.includes(String(rm.id)));
  };

  const getAvailableFinishedProducts = (currentIndex) => {
    const selectedIds = ingredientsList
      .filter((ing) => ing.item_type === "product")
      .map(ing => String(ing.id));

    return finishedProductList.filter(pm => !selectedIds.includes(String(pm.product_id || pm.id)));
  };

  const getRawMaterialName = (id, item_type = "raw") => {
    if (item_type === "product") {
      const prod = finishedProductList.find(p => String(p.product_id || p.id) === String(id));
      return prod ? `${prod.title} (Readymade Product)` : 'Unknown Product';
    }
    const material = rawMaterialList.find(rm => String(rm.id) === String(id));
    return material ? `${material.title} (Raw Material)` : 'Unknown Material';
  };

  const isLitreType = (id, item_type = "raw") => {
    if (!id || item_type === "product") return false;
    const material = rawMaterialList.find(rm => String(rm.id) === String(id));
    return material && String(material.type) === "2";
  };

  const getSelectedOption = (ing) => {
    if (!ing.id) return null;
    const itemType = ing.item_type || "raw";
    const val = `${itemType}_${ing.id}`;

    if (itemType === "product") {
      const prod = finishedProductList.find(p => String(p.product_id || p.id) === String(ing.id));
      return {
        value: val,
        label: prod ? prod.title : "Unknown Product",
        selectedLabel: prod ? `${prod.title} (Readymade Product)` : "Unknown Product",
        itemType: "product",
      };
    } else {
      const raw = rawMaterialList.find(rm => String(rm.id) === String(ing.id));
      return {
        value: val,
        label: raw ? raw.title : "Unknown Material",
        selectedLabel: raw ? `${raw.title} (Raw Material)` : "Unknown Material",
        itemType: "raw",
      };
    }
  };

  const buildSelectOptions = (currentIndex, currentIng) => {
    const rawOpts = getAvailableRawMaterials(currentIndex).map((rm) => ({
      value: `raw_${rm.id}`,
      label: rm.title,
      selectedLabel: `${rm.title} (Raw Material)`,
      itemType: "raw",
    }));

    const productOpts = getAvailableFinishedProducts(currentIndex).map((pm) => ({
      value: `product_${pm.product_id || pm.id}`,
      label: pm.title,
      selectedLabel: `${pm.title} (Readymade Product)`,
      itemType: "product",
    }));

    if (currentIng && currentIng.id) {
      const currentVal = `${currentIng.item_type || "raw"}_${currentIng.id}`;
      const currentItemType = currentIng.item_type || "raw";
      if (currentItemType === "product") {
        if (!productOpts.some(o => o.value === currentVal)) {
          const prod = finishedProductList.find(p => String(p.product_id || p.id) === String(currentIng.id));
          if (prod) {
            productOpts.unshift({
              value: currentVal,
              label: prod.title,
              selectedLabel: `${prod.title} (Readymade Product)`,
              itemType: "product",
            });
          }
        }
      } else {
        if (!rawOpts.some(o => o.value === currentVal)) {
          const raw = rawMaterialList.find(rm => String(rm.id) === String(currentIng.id));
          if (raw) {
            rawOpts.unshift({
              value: currentVal,
              label: raw.title,
              selectedLabel: `${raw.title} (Raw Material)`,
              itemType: "raw",
            });
          }
        }
      }
    }

    return [
      { label: "Raw Materials", options: rawOpts },
      { label: "Readymade / End Products", options: productOpts },
    ];
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    showLoader();

    const validationErrors = {};
    if (!formData.title) validationErrors.title = "Product title is required.";

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      hideLoader();
      return;
    }


    if (!validateIngredients()) {
      hideLoader();
      return;
    }

    if (!validateForm()) {
      hideLoader();
      return;
    }

    try {
      const formDataPayload = new FormData();
      Object.keys(formData).forEach((key) => {
        if (key === "product_image") {
          if (formData[key] instanceof File) {
            formDataPayload.append(key, formData[key]);
          } else if (formData[key] === "" || formData[key] === null) {
            formDataPayload.append(key, "");
          }
        } else if (formData[key] !== undefined && formData[key] !== null) {
          formDataPayload.append(key, formData[key]);
        }
      });
      const normalizedIngredients = ingredientsList.map(ing => {
        const itemType = ing.item_type || "raw";
        const isLitre = isLitreType(ing.id, itemType);
        return {
          ...ing,
          item_type: itemType,
          unit: ing.unit || (isLitre ? "Ml" : "grams")
        };
      });
      formDataPayload.append("ingridents", showIngredients ? JSON.stringify(normalizedIngredients) : "[]");

      console.log("Submitting data:", formDataPayload);

      if (AddorEdit) {
        await create_product_master(formDataPayload);
        toast.success("Product added successfully");
      } else {
        await updateProductMaster(selectedProduct?.product_id, formDataPayload);
        toast.success("Product updated successfully");
      }
      setCurrentPage(1);
      fetchProducts();
      handleCancel();
    } catch (error) {
      console.error("Error Product Master data:", error);
      toast.error(error?.response?.data?.message || "Error saving product");
    } finally {
      hideLoader();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const resetForm = () => {
    setFormData({
      title: "",
      package_qty: "",
      cat_id: "",
      subcat_id: "",
      sales_price: "",
      box_qty: "",
      box_sales: "",
      product_code: "",
      box_barcode: "",
      reorder_point: "",
      status: "1",
      shop_id: shopItem?.shop_id || "0",
      created_by: UserItem?.user_id || "0",
      // ware_id: shopItem?.ware_id || "1",
      product_image: "",
      weight_limit: "1",
    });
    setIngredientsList([]);
    setShowIngredients(true);
    setErrors({});
  };

  const handleCancel = () => {
    setShowModal(false);
    if (setSelectedProduct) {
      setSelectedProduct(null);
    }
    resetForm();
  };


  const filteredSubcategories = SubCategory.filter(
    (sub) => sub.category_id === parseInt(formData.cat_id)
  );


  const parseQtyToBase = (ing) => {
    const qty = Number(ing.qty) || 0;
    const unit = String(ing.unit || "").toLowerCase();
    if (unit === "kg" || unit === "kilogram" || unit === "kilograms" || unit === "li" || unit === "l" || unit === "litre" || unit === "liter" || unit === "litres") {
      return qty * 1000;
    }
    return qty;
  };

  const validateForm = () => {
    const totalIngredientsQtyInBase = ingredientsList.reduce(
      (sum, ing) => sum + parseQtyToBase(ing),
      0
    );

    const maxLimit = parseLimitToGrams(formData.weight_limit);

    if (totalIngredientsQtyInBase > maxLimit) {
      const displayTotal = totalIngredientsQtyInBase >= 1000
        ? `${Number((totalIngredientsQtyInBase / 1000).toFixed(3))} Kg/L`
        : `${totalIngredientsQtyInBase} grams/Ml`;
      const displayMax = maxLimit >= 1000
        ? `${Number((maxLimit / 1000).toFixed(3))} Kg/L`
        : `${maxLimit} grams/Ml`;

      const ok = window.confirm(
        `Total quantity = ${displayTotal} exceeds the allowed limit (max ${displayMax}).\n\nAre you sure you want to continue?`
      );

      if (!ok) {
        return false;
      }

      toast.info(
        `Total qty = ${displayTotal} (max allowed = ${displayMax})`
      );

      return true;
    }

    return true;
  };

  const totalIngredientsQtyInBase = ingredientsList.reduce(
    (sum, ing) => sum + parseQtyToBase(ing),
    0
  );


  return (
    <>
      <style>{`
        .opt-raw-material {
          color: #0b5ed7 !important;
          background-color: #f0f7ff !important;
          font-weight: 500;
        }
        .opt-readymade-product {
          color: #d97706 !important;
          background-color: #fffbe6 !important;
          font-weight: 500;
        }
      `}</style>
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-lg modal-dialog-centered" style={{ maxHeight: "90vh" }}>
            <div className="modal-content" style={{ maxHeight: "90vh", display: "flex", flexDirection: "column", overflow: "hidden" }}>
              <div className="modal-header" style={{ flexShrink: 0 }}>
                <h5 className="modal-title" style={{ fontFamily: "poppins" }}>
                  {selectedProduct ? "Edit Product" : "Add Product"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => handleCancel()}
                ></button>
              </div>

              <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", overflow: "hidden", flex: 1, margin: 0 }} encType="multipart/form-data">
                <div className="modal-body" style={{ fontFamily: "poppins", overflowY: "auto", flex: "1 1 auto", padding: "1rem" }}>
                  <div className="row g-3">

                    {/* Category Dropdown */}
                    <div className="col-md-6">
                      <label>Category</label>
                      <select
                        name="cat_id"
                        value={formData.cat_id}
                        onChange={handleChange}
                        className="form-control"
                        required
                      >
                        <option value="">Select Category</option>
                        {Category?.map((cat) => (
                          <option key={cat.id} value={cat.id}>
                            {cat.Categories}
                          </option>
                        ))}
                      </select>
                      {errors.cat_id && (
                        <small className="text-danger">{errors.cat_id}</small>
                      )}
                    </div>

                    {/* Product Title */}
                    <div className="col-md-6">
                      <label>Title <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        name="title"
                        value={formData.title}
                        onChange={handleChange}
                        className={`form-control ${errors.title ? 'is-invalid' : ''}`}
                        required
                      />
                      {errors.title && (
                        <div className="invalid-feedback">{errors.title}</div>
                      )}
                    </div>

                    {/* Ingredients Limit */}
                    <div className="col-md-6">
                      <label>Ingredients Limit <span className="text-danger">*</span></label>
                      <div className="input-group">
                        <input
                          type="number"
                          step="any"
                          name="weight_limit"
                          value={formData.weight_limit}
                          onChange={handleChange}
                          placeholder="e.g. 1, 2, 5, 87.6"
                          className="form-control"
                          min="0"
                          required
                        />
                        <span className="input-group-text">Kg</span>
                      </div>
                    </div>

                    {/* Product Image Upload */}
                    <div className="col-md-12">
                      <label className="form-label">Product Image (Optional)</label>
                      <div className="row align-items-center">
                        {/* Left Side: Uploaded image preview */}
                        <div className="col-auto">
                          <div style={{ position: "relative", width: "100px", height: "100px" }}>
                            <img
                              src={
                                formData.product_image
                                  ? (formData.product_image instanceof File
                                    ? URL.createObjectURL(formData.product_image)
                                    : formData.product_image)
                                  : "/assets/images/product_placeholder.png"
                              }
                              alt="Product Preview"
                              className="img-thumbnail"
                              style={{ width: "100px", height: "100px", objectFit: "cover" }}
                              onError={(e) => {
                                e.target.src = "/assets/images/product_placeholder.png";
                              }}
                            />
                          </div>
                        </div>

                        {/* Right Side: File Input and Remove button */}
                        <div className="col">
                          <div className="d-flex flex-column gap-2">
                            <input
                              type="file"
                              name="product_image"
                              accept="image/png, image/jpeg, image/jpg, image/webp"
                              onChange={(e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  // 5MB Limit
                                  if (file.size > 5242880) {
                                    toast.error("File size exceeds 5MB limit. Please choose a smaller file.");
                                    e.target.value = "";
                                    return;
                                  }

                                  const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
                                  if (!allowedTypes.includes(file.type)) {
                                    toast.error("Unsupported file format. Please choose a JPG, PNG, or WEBP image.");
                                    e.target.value = "";
                                    return;
                                  }

                                  setFormData((prev) => ({
                                    ...prev,
                                    product_image: file,
                                  }));
                                }
                              }}
                              className="form-control"
                            />
                            {formData.product_image && (
                              <div>
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => {
                                    setFormData((prev) => ({
                                      ...prev,
                                      product_image: "",
                                    }));

                                    const fileInput = document.getElementsByName("product_image")[0];
                                    if (fileInput) {
                                      fileInput.value = "";
                                    }
                                  }}
                                >
                                  <i className="bi bi-trash"></i> Remove Image
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="form-text mt-1 text-muted" style={{ fontSize: "12px" }}>
                        Supported formats: JPG, JPEG, PNG, WEBP. Maximum file size: 5MB. (Optional)
                      </div>
                    </div>

                    {/* Ingredients Section */}
                    <div className="col-md-12">
                      <div className="card">
                        <div className="card-header">
                          <div className="d-flex justify-content-between align-items-center">
                            <h6 className="mb-0">Product Ingredients({displayLimit(formData.weight_limit)} Limit)</h6>
                            <button
                              type="button"
                              className="btn btn-primary btn-sm"
                              onClick={addIngredient}
                            // disabled={totalIngredientsQty >= 1000}
                            >
                              <i className="bi bi-plus"></i> Add Ingredient
                            </button>
                          </div>
                        </div>
                        <div className="card-body">
                          {ingredientsList.length > 0 ? (
                            <div className="table-responsive">
                              <table className="table table-bordered table-sm">
                                <thead>
                                  <tr>
                                    <th>Raw Material <span className="text-danger">*</span></th>
                                    <th width="120">Quantity(Grams/Ml)</th>
                                    <th width="120">Unit</th>
                                    <th width="80">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {ingredientsList.map((ing, index) => (
                                    <tr key={index}>
                                      <td>
                                        <Select
                                          value={getSelectedOption(ing)}
                                          formatOptionLabel={(option, { context }) => {
                                            if (context === "value") {
                                              return option.selectedLabel || (option.itemType === "product" ? `${option.label} (Readymade Product)` : `${option.label} (Raw Material)`);
                                            }
                                            return option.label;
                                          }}
                                          onChange={(selectedOption) => {
                                            if (!selectedOption) {
                                              handleIngredientChange(index, "id", "");
                                              handleIngredientChange(index, "item_type", "raw");
                                              return;
                                            }
                                            const val = selectedOption.value;
                                            const parts = val.split("_");
                                            const itemType = parts[0];
                                            const itemId = parts.slice(1).join("_");

                                            if (itemType === "product") {
                                              const prod = finishedProductList.find(p => String(p.product_id || p.id) === String(itemId));
                                              if (prod) {
                                                handleIngredientChange(index, "id", prod.product_id || prod.id);
                                                handleIngredientChange(index, "item_type", "product");
                                                handleIngredientChange(index, "unit", "grams");
                                              }
                                            } else {
                                              const raw = rawMaterialList.find(rm => String(rm.id) === String(itemId));
                                              if (raw) {
                                                handleIngredientChange(index, "id", raw.id);
                                                handleIngredientChange(index, "item_type", "raw");
                                                const isLitre = String(raw.type) === "2";
                                                handleIngredientChange(index, "unit", isLitre ? "Ml" : "grams");
                                                if (raw.default_qty && !ing.qty) {
                                                  handleIngredientChange(index, "qty", raw.default_qty);
                                                }
                                              }
                                            }
                                          }}
                                          options={buildSelectOptions(index, ing)}
                                          styles={customSelectStyles}
                                          placeholder="Select Ingredient"
                                          isClearable
                                          isSearchable
                                          menuPortalTarget={document.body}
                                        />
                                      </td>

                                      <td>
                                        <input
                                          type="number"
                                          step="any"
                                          placeholder="Qty"
                                          value={ing.qty ?? ""}
                                          onChange={(e) => {
                                            let val = e.target.value;

                                            if (val === "" || val === null) {
                                              handleIngredientChange(index, "qty", "");
                                              return;
                                            }

                                            const numVal = Number(val);
                                            const unitStr = String(ing.unit || "").toLowerCase();
                                            const min = 0;
                                            const max = (unitStr === "kg" || unitStr === "kilograms" || unitStr === "li" || unitStr === "litre" || unitStr === "liter") ? 1000 : 1000000;

                                            if (numVal < min || numVal > max) {
                                              const ok = window.confirm(
                                                `Qty ${val} is outside allowed range (${min}-${max}).\nAre you sure you want to continue?`
                                              );

                                              if (ok) {
                                                toast.info(`Qty ${val} is outside allowed range`);
                                                handleIngredientChange(index, "qty", val);
                                              } else {
                                                handleIngredientChange(index, "qty", ing.qty ?? "");
                                              }

                                            } else {
                                              handleIngredientChange(index, "qty", val);
                                            }
                                          }}
                                          className="form-control form-control-sm"
                                          required
                                        />
                                      </td>

                                      <td>
                                        <select
                                          value={ing.unit || (isLitreType(ing.id) ? "Ml" : "grams")}
                                          onChange={(e) => handleIngredientChange(index, "unit", e.target.value)}
                                          className="form-control form-control-sm text-center"
                                          style={{ textAlign: "center" }}
                                          required
                                        >
                                          <option value="" style={{ textAlign: "center" }}>Select Unit</option>
                                          {isLitreType(ing.id) ? (
                                            <>
                                              <option value="Ml" style={{ textAlign: "center" }}>Ml</option>
                                              <option value="Li" style={{ textAlign: "center" }}>Li (Litre)</option>
                                            </>
                                          ) : (
                                            <>
                                              <option value="grams" style={{ textAlign: "center" }}>Grams</option>
                                              <option value="kg" style={{ textAlign: "center" }}>Kg (Kilograms)</option>
                                            </>
                                          )}
                                        </select>
                                      </td>
                                      <td>
                                        <button
                                          type="button"
                                          className="btn btn-danger btn-sm"
                                          onClick={() => setIngredientToDeleteIndex(index)}
                                          title="Remove ingredient"
                                        >
                                          <i className="bi bi-trash"></i>
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            <div className="alert alert-warning">
                              No ingredients added yet. Click "Add Ingredient" to start.
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                {/* Sticky Footer: Ingredients Summary Blue Stripe + Form Action Buttons */}
                <div
                  className="modal-footer border-top bg-white px-3 py-2"
                  style={{
                    flexShrink: 0,
                    backgroundColor: "#ffffff",
                    boxShadow: "0 -4px 10px rgba(0,0,0,0.05)",
                    display: "block"
                  }}
                >
                  {/* Ingredients Summary (Blue Stripe) */}
                  {ingredientsList.length > 0 && (
                    <div className="alert alert-info mb-2 py-2 px-3" style={{ borderRadius: "6px" }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Total Ingredients:</span>
                        <strong>{ingredientsList.length} item(s)</strong>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <span>Total Qty:</span>
                        <strong>
                          {totalIngredientsQtyInBase >= 1000
                            ? `${Number((totalIngredientsQtyInBase / 1000).toFixed(3))} Kg/L`
                            : `${totalIngredientsQtyInBase} grams/Ml`}
                        </strong>
                      </div>
                    </div>
                  )}

                  {/* Form Action Buttons */}
                  <div className="d-flex justify-content-end gap-2">
                    <button
                      type="button"
                      className="btn btn-secondary me-2"
                      onClick={() => handleCancel()}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-success">
                      <i className="bi bi-check-circle me-1"></i>
                      {selectedProduct ? "Update Product" : "Add Product"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation Modal for Ingredient Deletion */}
      {ingredientToDeleteIndex !== null && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.6)", zIndex: 1060 }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "420px" }}>
            <div className="modal-content" style={{ fontFamily: "poppins", borderRadius: "8px", overflow: "hidden" }}>
              <div className="modal-header py-2 px-3 bg-light">
                <h5 className="modal-title fs-6 fw-bold text-dark mb-0">Confirm Delete</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setIngredientToDeleteIndex(null)}
                ></button>
              </div>
              <div className="modal-body text-center py-4">
                <i className="bi bi-exclamation-triangle-fill text-warning mb-2" style={{ fontSize: "2.5rem" }}></i>
                <p className="mb-0 text-secondary fw-medium">
                  Are you sure you want to remove this ingredient?
                </p>
              </div>
              <div className="modal-footer py-2 px-3 bg-light justify-content-center gap-2">
                <button
                  type="button"
                  className="btn btn-secondary btn-sm px-3"
                  onClick={() => setIngredientToDeleteIndex(null)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm px-3"
                  onClick={() => {
                    removeIngredient(ingredientToDeleteIndex);
                    setIngredientToDeleteIndex(null);
                  }}
                >
                  Yes, Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
